import React from "react";
import { Timeline, Typography } from "antd";
import { SelectFacility } from "../../../components/SelectFacility";
import { Facility } from "../../../api/common/facility";
import { useInventoryTransferStore } from "../../../hooks/useInventoryTransferStore";
import * as S from "./styles";

export const SelectFacilityStep = () => {
  const { form, facility, setFacility } = useInventoryTransferStore();

  const filter = (name: string | null) => (options: Facility[]) => options.filter((o) => o.name !== name);
  const isErrorState = (key: "origin" | "destination") => form?.[key] === "invalid";

  return (
    <S.Container direction="vertical">
      <Typography.Title level={5}>Transfer From & To</Typography.Title>
      <Timeline>
        <Timeline.Item>
          <>
            <SelectFacility
              allowClear
              showSearch
              placeholder="Select Origin Facility"
              value={facility.origin || undefined}
              onSelect={(value) => setFacility("origin", value)}
              onClear={() => setFacility("origin", null)}
              filter={filter(facility.destination)}
              {...(isErrorState("origin") && { status: "error" })}
            />
            {isErrorState("origin") && <Typography.Text type="danger">Origin facility is required.</Typography.Text>}
          </>
        </Timeline.Item>
        <Timeline.Item>
          <>
            <SelectFacility
              allowClear
              showSearch
              placeholder="Select Destination Facility"
              value={facility.destination || undefined}
              onSelect={(value) => setFacility("destination", value)}
              onClear={() => setFacility("destination", null)}
              filter={filter(facility.origin)}
              {...(isErrorState("destination") && { status: "error" })}
            />
            {isErrorState("destination") && (
              <Typography.Text type="danger">Destination facility is required.</Typography.Text>
            )}
          </>
        </Timeline.Item>
      </Timeline>
    </S.Container>
  );
};
